const companyGroupsSettingEndpoints = {
  settings: (companyId: string) => `/companies/${companyId}/group/settings` as const
}

export default companyGroupsSettingEndpoints
